module.exports = __webpack_public_path__ + "static/img/csjz.97e14e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/csjz.png
// module id = 9kJq
// module chunks = 0